import type { MRT_ColumnDef } from "material-react-table";
import {
  CampaignDisplayStatus,
  CampaignLifecycleStatus,
  type AdminCampaignDto,
} from "Infrastructure/Api/Api";
import { Resources, type TFunction } from "Translations/Resources";
import { IconButton, Tooltip, Chip, Box } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link } from "Navigation/Link";
import { appUrl } from "Utils/UrlUtils";
import { getCampaignStatus } from "../campaignStatusUtils";
import { createSharedCampaignColumns } from "../sharedCampaignColumns";

const RESOURCES = Resources.Admin.Campaigns.Table;
const STATUS_RESOURCES = Resources.Admin.Campaigns.Status;

export const createColumns = (
  t: TFunction,
  onDelete: (id: number) => void,
): Array<MRT_ColumnDef<AdminCampaignDto>> => [
  ...createSharedCampaignColumns(t),
  {
    accessorKey: "status",
    header: t(RESOURCES.Status),
    size: 180,
    enableSorting: false,
    filterVariant: "select",
    filterSelectOptions: [
      {
        label: t(STATUS_RESOURCES.Active),
        value: CampaignDisplayStatus.Active,
      },
      {
        label: t(STATUS_RESOURCES.ActiveUnlimited),
        value: CampaignDisplayStatus.Unlimited,
      },
      {
        label: t(STATUS_RESOURCES.NotStarted),
        value: CampaignDisplayStatus.NotStarted,
      },
      {
        label: t(STATUS_RESOURCES.Finished),
        value: CampaignDisplayStatus.Finished,
      },
    ],
    Cell: ({ row }) => {
      const { description, label, color } = getCampaignStatus(row.original, t);
      return (
        <Tooltip title={description} placement="top">
          <Chip label={label} size="small" color={color} variant="outlined" />
        </Tooltip>
      );
    },
  },
  {
    accessorKey: "actions",
    header: t(RESOURCES.Actions),
    size: 120,
    enableColumnFilter: false,
    enableSorting: false,
    Cell: ({ row }) => (
      <Box display="flex" gap={1}>
        <Tooltip title={t(RESOURCES.Edit)}>
          <IconButton
            component={Link}
            to={`${appUrl("admin-campaigns-edit")}/${row.original.campaignID}/edit`}
            size="small"
            color="primary"
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        {row.original.status !== CampaignLifecycleStatus.Archived && (
          <Tooltip title={t(RESOURCES.Delete)}>
            <IconButton
              onClick={() => onDelete(row.original.campaignID)}
              size="small"
              color="error"
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    ),
  },
];
